const ASSET_BASE_URL = 'https://assets.contentstack.io/v3/assets/blt0e5ec1de4817c440';

export type NikonInteractiveDependencyProps = {
  src: string;
  name: string;
};

export const NIKON_INTERACTIVE_PAGE_DEPENDENCIES: Set<NikonInteractiveDependencyProps> = new Set([
  {
    src: `${ASSET_BASE_URL}/bltede75df1ebb667b6/gsap.min.js`,
    name: 'gsap',
  },
  {
    src: `${ASSET_BASE_URL}/blt6786d73307a1a01b/lottie.min.js`,
    name: 'lottie',
  },
  {
    src: `${ASSET_BASE_URL}/blta2cea481c77ec452/scrollTrigger.min.js`,
    name: 'scrollTrigger',
  },
  {
    src: `${ASSET_BASE_URL}/blt7652c81d0d6fe8bd/customEase.min.js`,
    name: 'customEase',
  },
  {
    src: `${ASSET_BASE_URL}/blta14cc5e47c634b58/TweenMax.min.js`,
    name: 'TweenMax',
  },
  {
    src: `${ASSET_BASE_URL}/blta16e59dddcd96ff7/noframework.waypoints.min.js`,
    name: 'noframework.waypoints',
  },
  {
    src: `${ASSET_BASE_URL}/bltc5c44341f02bcec2/nikon.slick.min.js`,
    name: 'nikon.slick',
  },
  {
    src: `${ASSET_BASE_URL}/blt7858bd0e135d1941/si.global.js`,
    name: 'si.global',
  },
  {
    src: `${ASSET_BASE_URL}/blt263d221ed385fa56/si.global-modal.js`,
    name: 'si.global-modal',
  },
    {
    src: `${ASSET_BASE_URL}/blt0801f6f64e954dfb/si.utils.min.js`,
    name: 'si.utils',
  },
  {
    src: `${ASSET_BASE_URL}/blt94a47a3df1f9d0ab/custom-pdp.min.js`,
    name: 'custom-pdp', 
  },
]);


